import { render, staticRenderFns } from "./OXOMI.vue?vue&type=template&id=af9a36bc"
import script from "./OXOMI.vue?vue&type=script&lang=js"
export * from "./OXOMI.vue?vue&type=script&lang=js"
import style0 from "./OXOMI.vue?vue&type=style&index=0&id=af9a36bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports